module.exports = __webpack_public_path__ + "static/mobilitat4-76da6b630a554cb0b8df3c54a3816b54.png";